import angular from 'angular';
import ActualAndProjectedSettlementsWidgetComponent from './actual-and-projected-settlements-widget-component';

export default angular
  .module('actual-and-projected-settlements-widget', [])
  .component('actualAndProjectedSettlementsWidget', new ActualAndProjectedSettlementsWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/actual-and-projected-settlements/actual-and-projected-settlements-widget-module.js